import request from '@/utils/request'

// 分页查询国际化配置列表
export function paginationI18n(query = {}, pagination) {
  return request({
    url: `/system/i18n/pagination?pageNum=${pagination.pageNum}&pageSize=${pagination.pageSize}`,
    method: 'post',
    data: query
  })
}

// 不分页查询国际化配置列表
export function listI18n(query = {}) {
  return request({
    url: '/system/i18n/list',
    method: 'post',
    data: query
  })
}

// 查询国际化配置详细
export function getI18n(i18nId) {
  return request({
    url: '/system/i18n/info/' + i18nId,
    method: 'get'
  })
}

// 新增国际化配置
export function addI18n(data) {
  return request({
    url: '/system/i18n/add',
    method: 'post',
    data: data
  })
}

// 修改国际化配置
export function updateI18n(data) {
  return request({
    url: '/system/i18n/edit',
    method: 'put',
    data: data
  })
}

// 删除国际化配置
export function delI18n(i18nId) {
  return request({
    url: '/system/i18n/remove/' + i18nId,
    method: 'delete'
  })
}
